
// @ts-nocheck
/* eslint-disable */
import {
  defineComponent,
  PropType
} from 'vue'
import { UPDATE_MODEL_EVENT, CHANGE_EVENT } from '@/components/utils/constants'
import { isValidComponentSize } from '@/components/utils/validators'
import { useCheckbox } from './useCheckbox'

export default defineComponent({
  name: 'MsCheckbox',
  props: {
    modelValue: {
      type: [Boolean, Number, String],
      default: () => undefined
    },
    label: {
      type: [Boolean, Number, String]
    },
    indeterminate: Boolean,
    disabled: Boolean,
    checked: Boolean,
    name: {
      type: String,
      default: undefined
    },
    trueLabel: {
      type: [String, Number],
      default: undefined
    },
    falseLabel: {
      type: [String, Number],
      default: undefined
    },
    id: {
      type: String,
      default: undefined
    },
    controls: {
      type: String,
      default: undefined
    },
    border: Boolean,
    size: {
      type: String as PropType<ComponentSize>,
      validator: isValidComponentSize
    }
  },
  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT],
  setup (props) {
    return useCheckbox(props)
  }
})
